import React from 'react'
import { UserButton, useUser } from '@clerk/clerk-react'

const Header: React.FC = () => {
  const { user } = useUser()
  
  return (
    <header className="header">
      <div className="header-left">
        <h1 className="header-title">Voyager Admin</h1>
        <span className="header-subtitle">Data & File Management</span>
      </div>
      <div className="header-right">
        {user && (
          <div className="user-section">
            <div className="user-info">
              <span className="user-name">{user.fullName || user.firstName || 'Admin User'}</span>
              <span className="user-email">{user.emailAddresses[0]?.emailAddress}</span>
            </div>
            <UserButton 
              afterSignOutUrl="/"
              appearance={{
                elements: {
                  avatarBox: "w-8 h-8"
                }
              }}
            />
          </div>
        )}
      </div>
    </header>
  )
}

export default Header